import { StorePart } from './components/QuantityColumn'
import OutgoingPopover from './components/OutgoingPopover'

export function render( storePart: StorePart ) {
	const { outgoingTransferDetails } = storePart
	return (
		<OutgoingPopover
			transfers={outgoingTransferDetails ?? []}
		/>
	)
}

export default {
	name: 'Outgoing',
	render,
}
